import "./JobDetailsModal.css";

function JobDetailsModal({ job, onClose }) {

  return (

    <div className="job-modal-overlay">

      <div className="job-modal">

        <button
          className="close-btn"
          onClick={onClose}
        >
          ✕
        </button>

        <h2>{job.title}</h2>

        <h3>{job.company}</h3>

        <div className="job-details">

          <p><strong>📍 Location:</strong> {job.location}</p>

          <p><strong>💼 Type:</strong> {job.type}</p>

          <p><strong>💰 Salary:</strong> {job.salary}</p>

          <p><strong>🎓 Qualification:</strong> {job.qualification}</p>

          <p><strong>📅 Experience:</strong> {job.experience}</p>

        </div>

        <div className="job-description">

          <h4>Description</h4>

          <p>{job.description}</p>

        </div>

        <div className="job-requirements">

          <h4>Requirements</h4>

          <ul>

            {job.requirements.map((item, index) => (

              <li key={index}>
                {item}
              </li>

            ))}

          </ul>

        </div>

        <button
          className="apply-btn"
          onClick={() => alert("Application Form will open")}
        >
          Apply Now
        </button>

      </div>

    </div>

  );
}

export default JobDetailsModal;